import { useTranslation } from "react-i18next";
import { Tab, TabOwnProps, Tabs } from "@mui/material";
import { INSIGHTS_ANALYSIS_TAB_ITEMS, ITab } from "../types";

const MainTabs = ({
  handleChange,
  value,
  tabsData,
}: {
  handleChange: (value: INSIGHTS_ANALYSIS_TAB_ITEMS) => void;
  value: string;
  tabsData: ITab[];
}) => {
  const { t } = useTranslation();
  return (
    <Tabs
      onChange={(_, newValue) => {
        handleChange(newValue);
      }}
      value={value}
      orientation="horizontal"
      sx={{
        borderBottom: "1px solid",
        borderColor: "divider",
        padding: "0 20px",
      }}
    >
      {tabsData.map((tab) => (
        <Tab
          key={tab.value}
          label={tab.iconOnly ? "" : t(tab.label)}
          title={tab.iconOnly ? t(tab.label)! : undefined}
          value={tab.value}
          icon={tab.icon as TabOwnProps["icon"]}
          iconPosition="start"
          sx={{
            minHeight: "48px",
            padding: "12px 20px",
            cursor: "pointer",
            "& .MuiTab-iconWrapper": {
              marginRight: "8px",
              fontSize: "20px",
            },
          }}
        />
      ))}
    </Tabs>
  );
};

export default MainTabs;
